import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundButton from 'Components/UI/RoundButton';
import { noop } from 'Helpers/PropTypes';

const useStyles = buildUseStyles('EditMessageActionBar', (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    margin: theme.spacing(1),
  },
  button: {
    margin: 0,
  },
}));

const EditMessageActionBar = ({
  className,
  onCancel,
  onSubmit,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box className={classNames(className, classes.root)}>
      <RoundButton
        className={classes.button}
        variant="contained"
        color="default"
        disableElevation
        onClick={onCancel}
      >
        {'Cancel'}
      </RoundButton>
      <RoundButton
        className={classes.button}
        variant="contained"
        color="primary"
        disableElevation
        onClick={onSubmit}
      >
        {'Save'}
      </RoundButton>
    </Box>
  );
};

EditMessageActionBar.defaultProps = {
  className: '',
  onCancel: noop,
  onSubmit: noop,
};

EditMessageActionBar.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

export { EditMessageActionBar };
